/**
 * Dirty-form registry — a module-level Set that tracks which forms are
 * currently unsaved. No React dependencies at this layer.
 *
 * Forms opt in via `useDirtyForm(id, isDirty)`. The auto-reload hook
 * (`useVersionAutoReload`) queries `anyDirtyForm()` before reloading so it
 * never interrupts an in-flight edit.
 */

const dirty = new Set<string>()

export function registerDirty(formId: string): void {
  dirty.add(formId)
}

export function unregisterDirty(formId: string): void {
  dirty.delete(formId)
}

export function anyDirtyForm(): boolean {
  return dirty.size > 0
}

/** Exposed for tests only — resets the registry between test cases. */
export function _resetDirtyRegistry(): void {
  dirty.clear()
}
